import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Timeout extends PureComponent {
	timeoutId = null

	componentDidMount() {
		const { fn, delay } = this.props;
		return this.timeoutId = setTimeout(fn, delay);
	}

	componentWillUnmount() {
		const { fn } = this.props;
		clearTimeout(this.timeoutId);
	}

	render () {
		return null;
	}

	static propTypes = {
		fn: PropTypes.func.isRequired,
		delay: PropTypes.number.isRequired,
	}

	static defaultProps = {
		delay: 2000,
		fn: () => {},
	}
}

export default Timeout;
